import { useTranslation } from "react-i18next";

function usePaymentStatus(status: string) {
	const { t } = useTranslation("payments", { keyPrefix: "status" });
	return t(status);
}

export default usePaymentStatus;
